import { reactive } from 'vue'
import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { useRouterUtil, RouterTypeData } from '@/model/router/router'
import { useScreen } from '@/model/screen/screenTransition'
import { UserAgreeLicenseState } from './userAgreeLicenseState'
import { checkFlowRedirect } from './userNoAuth'

/**
 * ライセンス契約書同意画面のDOM初期処理を実施する
 * @param state 状態
 * @param store vuex
 * @param router vue router
 */
const initDom = async (state: UserAgreeLicenseState, store: Store<StoreState>, router: Router) => {
  // 初期処理チェック(F5等でusernameが未設定の場合はTOP画面に遷移)
  await checkFlowRedirect(state.username, store, router)
}

/**
 * ライセンス契約書同意画面の初期状態を取得する
 * @param props propsデータ
 * @returns reactiveした初期状態
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stateAgreeLicense = (props: any): UserAgreeLicenseState => {
  const state = reactive<UserAgreeLicenseState>({
    username: props.username,
    agreeButtonDisabled: true,
    redirect: props.redirect,
    downloadKey: props.downloadKey,
  })
  return state
}

/**
 * 同意してワンタイムパスワード発行画面に遷移する
 * @param state 画面状態
 * @param router vueRouter
 */
const userAgreeLicense = async (state: UserAgreeLicenseState, router: Router) => {
  // ワンタイムパスワード発行画面に遷移
  const data: RouterTypeData.EntryAuthSendData = {
    username: state.username,
    type: RouterTypeData.ENTRY_TYPE.NEW,
    redirect: state.redirect,
    downloadKey: state.downloadKey,
  }
  useRouterUtil(router).entryAuthSend(data)
}

/**
 * TOP画面に遷移する
 * @param state 画面状態
 * @param store vuex
 * @param router vueRouter
 */
const topRedirect = async (state: UserAgreeLicenseState, store: Store<StoreState>, router: Router) => {
  // TOP画面に遷移する
  const input: RouterTypeData.LoginTopData = {
    redirect: state.redirect,
    downloadKey: state.downloadKey,
  }
  useScreen().topRedirectNormal(store, router, input)
}

export { initDom, stateAgreeLicense, userAgreeLicense, topRedirect }
